export interface Placement {
  targetId: string;
  sizes: number[][];
  position: number | null;
}

export type PlacementWithoutPosition = Omit<Placement, 'position'>;

export interface PlacementConfig {
  [device: string]: PlacementWithoutPosition[];
}

export const AdContexts = {
  FRONTPAGE: 'frontpage',
  SECTION: 'section',
  REVIEW: 'review',
  GUIDE: 'guide',
  LIST: 'list',
} as const;
export type AdContext = (typeof AdContexts)[keyof typeof AdContexts];

export const PageType = {
  FRONTPAGE: 'frontpage',
  ARTICLE: 'article',
} as const;
export type PageType = (typeof PageType)[keyof typeof PageType];

export const ContentType = {
  AD: 'ad',
  BUNDLE: 'bundle',
  CHUNK: 'chunk',
  IMAGE: 'image',
  TEASER: 'teaser',
  FULL_WIDTH_TEASER: 'fullWidthTeaser',
  WIDGET: 'widget',
} as const;

export const Action = {
  GROUP_START: 'group-start',
  GROUP_END: 'group-end',
} as const;

export const Device = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
} as const;
export type Device = (typeof Device)[keyof typeof Device];

export const AdCssClass = {
  FRONTPAGE: 'advertory-ad-frontpage',
  ARTICLE: 'advertory-ad-article',
} as const;

export const ReservedSlotId = {
  TAKEOVER: 'takeover',
  SPONSORSTRIPE: 'sponsorstripe',
  NETBOARD_3: 'netboard_3',
  BOARD_3: 'board_3',
} as const;

export const NETBOARD_MARKER = 'netboard';
export const BRANDBOARD_MARKER = 'brandboard';

type AdInsertionRuleBase = {
  interval: number;
  anchorBefore: boolean;
  pageType: PageType;
};
export type AdInsertionRule =
  | (AdInsertionRuleBase & { countAction: string })
  | (AdInsertionRuleBase & { countExcept: string[] })
  | (AdInsertionRuleBase & { count: string[] });
